import { AfterViewInit, Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { delay } from 'rxjs/operators';

import { Address, City, Country, Id, StreetType } from '../../../domain/data';
import { BaseUI } from '../../base.ui';
import { ErrorDialog } from '../../dialog/error/error.dialog';
import { GetCitiesUseCase, GetCountriesUseCase, GetStreetTypesUseCase } from '../../../../core';
import { ParentEvents } from '../../../utils/parent-events.service';

let nextUniqueId = 0;

@Component({
    selector: 'thr-full-data-form-address',
    templateUrl: './full-data-form-address.component.html',
    styleUrls: ['./full-data-form-address.component.scss'],
})
export class FullDataFormAddressComponent extends BaseUI implements AfterViewInit, OnDestroy, OnInit {
    public prefix: string;
    public cities: City[] = [];
    public countries: Country[] = [];
    public streetTypes: StreetType[] = [];

    @Input()
    address: Address;

    @Input()
    isDisabled = false;

    // tslint:disable-next-line:no-output-native
    @Output()
    change: EventEmitter<Address> = new EventEmitter();

    constructor(
        parentEvents: ParentEvents,
        private dialog: MatDialog,
        private getCitiesUseCase: GetCitiesUseCase,
        private getCountriesUseCase: GetCountriesUseCase,
        private getStreetTypesUseCase: GetStreetTypesUseCase
    ) {
        super(parentEvents);
    }

    ngOnInit() {
        this.prefix = `tfa-${nextUniqueId++}-`;
        this.getCountries();
        this.getCities();
        this.getStreetTypes();
    }

    private getCountries() {
        this.getCountriesUseCase
            .bind()
            .pipe(delay(1)) // prevent ExpressionChangedAfterItHasBeenCheckedError
            .subscribe((transaction) => {
                if (transaction.isSuccess) {
                    this.countries = transaction.data as Country[];
                } else if (!transaction.isAuthError) {
                    this.dialog.open(ErrorDialog);
                }
            });
    }

    private getCities() {
        if (this.address.country) {
            this.getCitiesUseCase
                .bind({ countryId: Id.fromString(this.address.country) })
                .pipe(delay(1)) // prevent ExpressionChangedAfterItHasBeenCheckedError
                .subscribe((transaction) => {
                    if (transaction.isSuccess) {
                        this.cities = transaction.data as City[];
                    } else if (!transaction.isAuthError) {
                        this.dialog.open(ErrorDialog);
                    }
                });
        }
    }

    private getStreetTypes() {
        this.getStreetTypesUseCase
            .bind()
            .pipe(delay(1)) // prevent ExpressionChangedAfterItHasBeenCheckedError
            .subscribe((transaction) => {
                if (transaction.isSuccess) {
                    this.streetTypes = transaction.data as StreetType[];
                } else if (!transaction.isAuthError) {
                    this.dialog.open(ErrorDialog);
                }
            });
    }

    onChange() {
        this.change.emit(this.address);
    }

    onCountryChange() {
        this.getCities();
    }
}
